<template>
  <div class="space-y-4 px-4"><slot /></div>
</template>

<script setup></script>
